import { CircleAlertIcon, InfoIcon, TriangleAlertIcon, XIcon } from "./icons"

import type { ReactNode } from "react"

type Tone = "info" | "warning" | "error"

const TONES: Record<Tone, { className: string; Icon: typeof InfoIcon }> = {
  info: { className: "alert-info", Icon: InfoIcon },
  warning: { className: "alert-warning", Icon: TriangleAlertIcon },
  error: { className: "alert-error", Icon: CircleAlertIcon },
}

interface Props {
  tone: Tone
  // A one-click fix for what the notice points out.
  action?: { label: string; onClick: () => void; disabled?: boolean }
  onDismiss: () => void
  children: ReactNode
}

export const Notice = ({ tone, action, onDismiss, children }: Props) => {
  const { className, Icon } = TONES[tone]

  return (
    <div
      role={tone === "error" ? "alert" : undefined}
      className={`alert flex gap-3 rounded-lg alert-soft px-3 py-2 text-sm ${className}`}
    >
      <Icon className="size-4 shrink-0" />
      <p className="flex-1">{children}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          disabled={action.disabled}
          className="btn rounded-full font-bold btn-xs btn-neutral"
        >
          {action.label}
        </button>
      )}
      <button
        type="button"
        aria-label="Dismiss"
        onClick={onDismiss}
        className="btn btn-circle btn-ghost btn-xs"
      >
        <XIcon className="size-3.5" />
      </button>
    </div>
  )
}
